import cx from 'clsx';
import type { ComponentPropsWithoutRef, ReactElement } from 'react';
import styles from './spinner.module.css';

interface SpinnerProps extends ComponentPropsWithoutRef<'svg'> {
  size?: 'small' | 'medium' | 'large';
}

export function Spinner({ size = 'medium', className, ...props }: SpinnerProps): ReactElement {
  return (
    <svg
      className={cx(className, styles.spinner, styles[size])}
      data-testid="spinner"
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle className={styles.track} cx="12" cy="12" pathLength="100" r="10.5" />
    </svg>
  );
}
